import React from 'react';
import {
  Navigate,
  Outlet,
  useLocation,
} from 'react-router-dom';
import Spinner from 'pages/Dashboard/components/Spinner';
import Navigation from 'pages/Dashboard/pages/Dashboard/Navigation';
import {
  DASHBOARD_PATHS,
  DEFAULT_EMR_PATH,
} from 'views/EMR/access';
import {
  usePCCAvailability,
} from 'views/EMR/hooks/pcc';

type DashboardContentProps = {
  isCcmAvailable: boolean;
};

function DashboardContent({ isCcmAvailable }: DashboardContentProps) {
  const location = useLocation();
  const shouldRedirectFromCcm = (
    location.pathname === DASHBOARD_PATHS.CCM
    && !isCcmAvailable
  );

  return shouldRedirectFromCcm ? (
    <Navigate to={DASHBOARD_PATHS.OVERVIEW} replace />
  ) : (
    <>
      <Navigation />
      <div className="flex flex-1 w-full pt-4 overflow-y-hidden">
        <Outlet />
      </div>
    </>
  );
}

type ActivatedDashboardProps = {
  isPCCAvailable: boolean;
  isCcmAvailable: boolean;
};

function ActivatedDashboard({
  isPCCAvailable,
  isCcmAvailable,
}: ActivatedDashboardProps) {
  return isPCCAvailable ? (
    <DashboardContent isCcmAvailable={isCcmAvailable} />
  ) : (
    <Navigate to={DEFAULT_EMR_PATH} replace />
  );
}

export default function Dashboard() {
  const {
    isLoading,
    isError,
    isPCCAvailable,
    isCcmAvailable,
  } = usePCCAvailability();

  return isLoading ? (
    <div className="flex flex-1 items-center justify-center">
      <Spinner />
    </div>
  ) : (
    <ActivatedDashboard
      isPCCAvailable={!isError && isPCCAvailable}
      isCcmAvailable={isCcmAvailable}
    />
  );
}
